import { Edit } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconPen(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <Edit />
    </IconWrapper>
  );
}
